import React, { useState } from "react"
import "./App.css"

//COMPONENTS
import ImagePreview from "./components/ImagePreview"
import DoorCustomizer from "./components/DoorCustomizer"
import Print from "./components/Print"
import Page from "./components/Page"

import useCreateImgLink from "./hooks/useCreateImgLink"
import useDropdownFilter from "./hooks/useDropdownFilter"
import { DROPDOWN_VALUES } from "./data/DROPDOWN_VALS"
import { useEffect } from "react"

function App() {
  const [width, setWidth] = useState("Choose an option")
  const [height, setHeight] = useState("Choose an option")
  const [style, setStyle] = useState("Choose an option")
  const [lites, setLites] = useState("Choose an option")
  const [litesName, setLitesName] = useState("")
  const [styleNames, setStyleNames] = useState("")

  const [dropDownValues] = useDropdownFilter(style, setLites, lites)
  const [imgSrc, message, setImgSrc, setMessage] = useCreateImgLink(lites, width, height, style)

  const handleChange = (label, e) => {
    const val = e.target.value
    if (label === "Width") {
      setWidth(val)
    }
    if (label === "Height") {
      setHeight(val)
    }
    if (label === "Style") {
      setLites("SD")
      setStyle(val)
      setStyleNames(Object.keys(DROPDOWN_VALUES.Style).find(key => DROPDOWN_VALUES.Style[key] === val))
    }
    if (label === "Lites") {
      setLites(val)
      setLitesName(Object.keys(DROPDOWN_VALUES.Lites).find(key => DROPDOWN_VALUES.Lites[key] === val))
    }
  }

  useEffect(() => {
    if (style === "FULL-VIEW" || style === "HARMONY-LEFT" || style === "HARMONY-RIGHT") {
      setLitesName("")
    } else {
      setLitesName("Solid Door")
    }
  }, [style])

  return (
    <Page classes="lg:grid grid-cols-2 gap-10 h-screen" title="Garage Door Builder">
      <ImagePreview message={message} src={imgSrc} setImgSrc={setImgSrc} setMessage={setMessage} />
      <DoorCustomizer setLites={setLites} dropDownValues={dropDownValues} width={width} height={height} style={style} lites={lites} handleChange={handleChange} />
      <Print lites={litesName} width={width} height={height} style={styleNames} />
    </Page>
  )
}

export default App
